import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import Button from "../../components/base/Button";
import SEO from "../../components/base/SEO";
// import { useTranslation } from "react-i18next";

export default function About() {
  // const { t } = useTranslation();

  const values = [
    {
      icon: "ri-lightbulb-line",
      title: "創新驅動",
      description: "持續投入研發，運用最新科技為客戶創造價值",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "客戶至上",
      description: "以客戶需求為中心，提供量身定制的解決方案",
    },
    {
      icon: "ri-shield-check-line",
      title: "品質保證",
      description: "嚴格的品質控制，確保產品穩定可靠",
    },
    {
      icon: "ri-team-line",
      title: "團隊合作",
      description: "專業團隊協作，為客戶提供全方位支援",
    },
  ];

  const achievements = [
    {
      number: "50+",
      label: "成功案例",
      icon: "ri-trophy-line",
    },
    {
      number: "99.9%",
      label: "系統穩定性",
      icon: "ri-shield-check-line",
    },
    {
      number: "24/7",
      label: "技術支援",
      icon: "ri-customer-service-line",
    },
    {
      number: "100%",
      label: "客戶滿意度",
      icon: "ri-heart-line",
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="關於我們 - AUTOCHAIN 智能物流科技公司"
        description="AUTOCHAIN TECHNOLOGY 是專注於物流科技解決方案的創新企業。提供價廉物美的WMS和TMS系統，幫助企業實現數位化轉型，提升營運效率。50+成功案例，99.9%系統穩定性，24/7技術支援。"
        keywords="AUTOCHAIN, 物流科技, 智能物流公司, WMS供應商, TMS供應商, 香港物流軟件, 倉儲系統開發"
        canonicalUrl="/about"
      />
      
      {/* Structured Data - Organization */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "AUTOCHAIN TECHNOLOGY",
        "alternateName": "AUTOCHAIN",
        "url": "https://autochain.com.hk",
        "logo": "https://autochain.com.hk/android-chrome-512x512.png",
        "description": "專為香港中小企設計嘅 WMS 倉庫管理系統及 TMS 運輸管理系統供應商",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "香港",
          "addressCountry": "HK"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+852-9425-2903",
          "contactType": "sales",
          "availableLanguage": ["zh-HK", "en"]
        },
        "foundingDate": "2020",
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "minValue": 10,
          "maxValue": 50
        }
      })}} />
      
      {/* Structured Data - Breadcrumb */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "首頁", "item": "https://autochain.com.hk/" },
          { "@type": "ListItem", "position": 2, "name": "關於我們", "item": "https://autochain.com.hk/about" }
        ]
      })}} />
      
      <Header />

      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center py-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('./2b46bb48d444d8aa30d1e9a82a91612f.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">關於我們</h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              專業經驗，致力於為物流行業提供價廉物美的智能解決方案
            </p>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                我們的故事
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                AUTOCHAIN TECHNOLOGY
                是一家專注於物流科技解決方案的創新企業。作為一間充滿活力的startup公司，我們的團隊在物流行業擁有豐富經驗，始終堅持為客戶提供價廉物美的產品和服務。
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                我們深知物流行業的痛點和挑戰，因此致力於開發實用、高效且經濟實惠的WMS和TMS系統。通過不斷的技術創新和產品優化，我們已經成功服務了眾多企業，幫助他們實現數位化轉型，提升營運效率。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                我們相信，優質的物流解決方案不應該是大企業的專利。無論您是中小企業還是大型集團，我們都能為您提供符合預算且功能強大的解決方案。
              </p>
            </div>
            <div className="relative">
              <img
                src="./408599c07f0a5b66cd9e69018363b443.jpg"
                alt="公司團隊工作環境"
                className="rounded-2xl shadow-xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Founding Story */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">創辦歷程</h2>
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              AUTOCHAIN 的創辦源於一個簡單的觀察：香港的中小型物流企業長期面對「大系統太貴、細系統唔夠用」的困境。市面上的 WMS 和 TMS 系統，要麼是國際大廠的企業級方案，動輒數十萬甚至過百萬的投資；要麼是功能簡陋的入門級產品，無法滿足實際營運需求。
            </p>
            <p className="mb-6">
              我們的創辦團隊成員曾在多間物流企業工作，親身經歷過用 Excel 管理倉庫的混亂、用 WhatsApp 調度司機的低效、以及因為系統不互通而導致的重複輸入和人為錯誤。我們深信，一定有更好的方法。
            </p>
            <p className="mb-6">
              2020年，我們決定自己動手，開發一套真正切合香港市場需要的物流管理系統。我們的目標很明確：功能要夠用、價錢要合理、操作要簡單。經過多年的開發和實戰測試，AUTOCHAIN 的 WMS 和 TMS 系統終於面世，並已成功服務超過 50 間本地企業。
            </p>
            <p>
              今天，我們仍然保持著創業初期的熱誠和專注。每一個功能的開發，都是基於客戶的真實需求；每一次系統更新，都是為了讓用戶的工作更輕鬆。我們不追求成為最大的物流軟件公司，但我們立志成為最了解香港物流業的科技夥伴。
            </p>
          </div>
        </div>
      </section>

      {/* Team Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">專業團隊</h2>
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              AUTOCHAIN 的團隊由一群對物流科技充滿熱誠的專業人士組成。我們的成員來自不同背景，包括物流營運、軟件開發、用戶體驗設計和客戶服務等領域，這種多元化的組合讓我們能夠從不同角度理解和解決客戶的問題。
            </p>
            <p className="mb-6">
              我們的技術團隊擁有豐富的系統開發經驗，熟悉最新的雲端技術和移動應用開發。更重要的是，團隊中有多位成員曾在物流企業擔任營運職位，深明倉庫和運輸管理的實際運作，能夠將這些經驗轉化為實用的系統功能。
            </p>
            <p>
              我們的客戶服務團隊以「用心服務」為宗旨，不只是解答技術問題，更會主動了解客戶的業務需求，提供最適合的建議。無論是系統設定、員工培訓還是日常支援，我們都會全程陪伴，確保客戶能夠充分發揮系統的價值。
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-focus-3-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                我們的使命
              </h3>
              <p className="text-gray-700 leading-relaxed">
                透過創新的物流科技解決方案，幫助企業提升效率、降低成本，實現可持續發展。我們致力於讓每一家企業都能享受到先進的物流管理技術，不論規模大小。
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                我們的願景
              </h3>
              <p className="text-gray-700 leading-relaxed">
                成為亞太地區最受信賴的物流科技解決方案提供商，以價廉物美的產品和卓越的服務，推動整個物流行業的數位化轉型和智能化發展。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              我們的核心價值
            </h2>
            <p className="text-xl text-gray-600">指引我們前進的核心理念</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-xl hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-20" style={{ backgroundColor: "#0cb3a8" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">我們的成就</h2>
            <p className="text-xl text-blue-100">用數字說話的專業實力</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className="text-center bg-white/10 rounded-xl p-8 backdrop-blur-sm"
              >
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <i
                    className={`${achievement.icon} text-3xl text-blue-600`}
                  ></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">
                  {achievement.number}
                </div>
                <div className="text-blue-100 font-medium">
                  {achievement.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              為什麼選擇我們
            </h2>
            <p className="text-xl text-gray-600">作為startup的優勢與承諾</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-money-dollar-circle-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">價廉物美</h3>
              <p className="text-gray-700">
                作為startup公司，我們沒有傳統大企業的高昂成本負擔，能夠以更優惠的價格提供高品質的解決方案。
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">快速響應</h3>
              <p className="text-gray-700">
                靈活的組織架構讓我們能夠快速響應客戶需求，提供及時的技術支援和產品更新。
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">貼心服務</h3>
              <p className="text-gray-700">
                我們重視每一位客戶，提供個人化的服務體驗，確保您的需求得到最佳滿足。
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">專業技術</h3>
              <p className="text-gray-700">
                團隊擁有豐富的物流行業經驗，深度了解行業需求，提供最專業的技術解決方案。
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-refresh-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">持續創新</h3>
              <p className="text-gray-700">
                不斷研發新功能，緊跟行業趨勢，確保您的系統始終保持領先地位。
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">長期夥伴</h3>
              <p className="text-gray-700">
                我們不只是供應商，更是您的長期合作夥伴，與您一起成長，共創成功。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            準備與我們合作？
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            讓我們的專業經驗為您的物流業務帶來革命性的改變
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => {
                const message = encodeURIComponent(
                  "您好！我想了解更多關於 AUTOCHAIN 的服務，希望獲取詳細資料。"
                );
                window.open(
                  `https://wa.me/85294252903?text=${message}`,
                  "_blank"
                );
              }}
              className="font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center text-white hover:bg-opacity-90 focus:ring-4 focus:ring-opacity-30 px-8 py-4 text-lg"
              style={{ backgroundColor: "rgb(67, 209, 199)" }}
            >
              立即聯絡我們
            </button>
            <Button
              variant="outline"
              size="lg"
              className="text-lg px-8 py-4 bg-white/10 border-white text-white hover:bg-white hover:text-gray-900"
            >
              了解更多服務
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
